import { render } from "./Kreditojs.vue?vue&type=template&id=354dc6af"
import script from "./Kreditojs.vue?vue&type=script&lang=ts"
export * from "./Kreditojs.vue?vue&type=script&lang=ts"

import "./Kreditojs.vue?vue&type=style&index=0&id=354dc6af&lang=scss"
script.render = render

export default script